export default __webpack_public_path__ + "static/media/custom-characters.ff4c5447.jpg";